import { AppHeader } from '@9b3kuq5phwuk4txw/kiban-react-ui/app-header'
import { useRouterState } from '@tanstack/react-router'
import { toast } from 'sonner'
import { ApiError, logout } from '@/lib'
import { DRACAENA_BASE_URL, isLocalDev } from '@/lib/env'
import { useChangePassword } from '@/shared-hooks/useChangePassword'
import { useAuthStore } from '@/stores/auth'
import { useDevtoolsStore } from '@/stores/devtools'
import packageJson from '../../package.json'

function handleHomeClick() {
  if (isLocalDev) {
    window.location.href = DRACAENA_BASE_URL || 'http://localhost:8080'
  } else {
    window.location.href = '/'
  }
}

function resolvePasswordChangeError(err: unknown): string {
  const message = err instanceof ApiError ? err.message.toLowerCase() : ''
  if (message.includes('invalid')) {
    return '現在のパスワードが間違っています'
  }
  return '予期しないエラーが発生しました'
}

export function AppHeaderContainer() {
  const { user } = useAuthStore()
  const router = useRouterState()
  const { mutateAsync: changePassword } = useChangePassword()
  const { showQueryDevtools, showRouterDevtools, setShowQueryDevtools, setShowRouterDevtools } = useDevtoolsStore()

  const currentPath = router.location.pathname
  const headerTitle = currentPath.startsWith('/inquiries') ? '引合管理' : 'キャプテンポータル'
  const showSidebarTrigger = currentPath.startsWith('/opportunities')

  return (
    <AppHeader
      appName='キャプテンポータル'
      userEmail={user?.email}
      headerTitle={headerTitle}
      showSidebarTrigger={showSidebarTrigger}
      packageVersion={packageJson.version}
      onHomeClick={handleHomeClick}
      onLogout={logout}
      onChangePassword={changePassword}
      onPasswordChangeSuccess={() => toast.success('パスワードが変更されました')}
      resolvePasswordChangeError={resolvePasswordChangeError}
      showDevtoolsMenu={import.meta.env.DEV}
      devtools={{
        showQueryDevtools,
        showRouterDevtools,
        setShowQueryDevtools,
        setShowRouterDevtools,
      }}
    />
  )
}
